import { render, staticRenderFns } from "./OrderWhatsSendBudgedButton.vue?vue&type=template&id=3ebd82da&scoped=true"
import script from "./OrderWhatsSendBudgedButton.vue?vue&type=script&lang=js"
export * from "./OrderWhatsSendBudgedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd82da",
  null
  
)

export default component.exports